import { useSelector } from 'react-redux';
import { accountSelectors } from '../redux/modules/account';

export const useActiveAccountId = (): string =>
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  useSelector(accountSelectors.selectActiveAccountId);

export default useActiveAccountId;
